<template>
  <el-dialog custom-class="add-requirement-dialog" title="发布需求" :visible.sync="dialogVisible" width="68%" :close-on-click-modal="false">
    <div
      class="user-center__requirement-edit-container user-center__common-child-container --for-edit"
    >
      <div class="requirement-edit__wrapper center-common-form-wrapper">
        <!-- 顶部 -->
        <!-- <sub-page-header>
          <template #title>
            <router-link
              tag="div"
              :to="nav.url"
              active-class="active"
              class="title__front-item"
              v-for="(nav, index) in breadcrumbs"
              :key="index"
            >{{ nav.name }}</router-link>
          </template>
          <template #hint>
            <p>
              为保证上架速度，请保证设计包完整度及真实性，带有
              <i class="circle"></i>的项目是必填的项目
            </p>
          </template>
        </sub-page-header> -->
        <!-- form部分 -->
        <user-form
          :form="form"
          :rules="rules"
          :render="renderItems"
          ref="postForm"
          @formValidated="onSubmit"
          @formValidateError="onFormError"
          :divider="dividerConfig"
        >
          <template #hint>
            <div class="form-hint__text">
              <p>
                免费发布您的手机号将在前台公布，付费发布您的手机号将被隐藏，公开手机号发布您的手机号将在前台显示，任何人都可以与您联系，该情况适合简单的材料咨询，
                隐藏手机号发布只有付费用户与特定商家才能与您联系，该情况适合您特定的材料需求。
              </p>
            </div>
          </template>
          <template #bts>
            <el-button
              v-for="(bt, btindex) in renderBts"
              :key="btindex"
              class="bt__item"
              :class="[bt.type === 'submit' ? 'bt__submit' : 'bt__cancel', bt.classes]"
              @click="bt.onClick && bt.onClick(bt.extendParams, $event)"
              :data-index="btindex"
              :loading="Number(btCurrentIndex) === Number(btindex) && loading"
              :disabled="Number(btCurrentIndex) !== Number(btindex) && loading"
            >{{ bt.label }}</el-button>
          </template>
        </user-form>
      </div>
      <pay-qrcode
        :visible.sync="pay.visible"
        :body="pay.desc"
        :price="pay.price"
        @afterPay="afterPay"
      ></pay-qrcode>
    </div>
  </el-dialog>
</template>

<script>
import { molds } from "@/api/common";
import { create } from "@/api/requirement";
import { mapState } from "vuex";
import PayQrcode from "@/pages/common/payQrcode.vue";
import SubPageHeader from "../user/_pageHeader.vue";
import UserForm from "../user/_form.vue";

export default {
  components: {
    SubPageHeader,
    UserForm,
    PayQrcode
  },
  props: {
    id: undefined
  },
  computed: mapState({
    molds: state => state.molds,
    cities: state => state.cities,
    isNew() {
      return this.id === undefined;
    }
  }),
  data() {
    return {
      dialogVisible: false,
      loading: false,
      btCurrentIndex: -1,
      breadcrumbs: [
        {
          name: "发布需求",
          url: "/my/requirement/create/"
        }
      ],
      form: {
        title_picture_id: [],
        picture_ids: [],
        name: "",
        mold_id: "",
        mold_ids: [],
        prov_id: "",
        address: "",
        function: "",
        scale: "",
        phone: "",
        content: "",
        is_hide: "",
        loading: false
      },
      rules: {
        title_picture_id: [
          {
            required: true,
            message: "请上传封面",
            trigger: "change"
          }
        ],
        picture_ids: [
          {
            required: true,
            message: "请上传需求图片",
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            message: "请填写需求名称",
            trigger: "blur"
          }
        ],
        company: [
          {
            required: true,
            message: "请填写业主",
            trigger: "blur"
          }
        ],
        project: [
          {
            required: true,
            message: "请填写设计单位",
            trigger: "blur"
          }
        ],
        mold_id: [
          {
            required: true,
            message: "请选择分类",
            trigger: "change"
          }
        ],
        mold_ids: [
          {
            required: true,
            message: "请选择子分类",
            trigger: "change"
          }
        ],
        prov_id: [
          {
            required: true,
            message: "请选择城市",
            trigger: "change"
          }
        ],
        address: [
          {
            required: true,
            message: "请填写具体地址",
            trigger: "blur"
          }
        ],
        function: [
          {
            required: true,
            message: "请填写具体功能",
            trigger: "blur"
          }
        ],
        scale: [
          {
            required: true,
            message: "请填写具体规模",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请填写手机号码",
            trigger: "blur"
          },
          {
            pattern: /^0{0,1}(1)[0-9]{10}$/,
            message: "手机号码格式不正确",
            trigger: "blur"
          }
        ],
        content: [
          {
            required: true,
            message: "请填写内容详情",
            trigger: "blur"
          }
        ]
      },
      renderItems: {
        title_picture_id: {
          fileList: [],
          type: "img",
          title: "上传封面图片",
          hint: "支持上传jpg/png/gif格式。",
          limit: 1
        },
        picture_ids: {
          fileList: [],
          type: "img",
          title: "上传需求图片",
          hint: "支持上传jpg/png/gif格式，不超过10M，最多6张",
          limit: 6
        },
        name: {
          type: "text",
          title: "需求名称",
          hint: "您的名称您做主",
          length: "long"
        },
        company: {
          type: "text",
          title: "业主",
          hint: "请填写您的业主",
        },
        project: {
          type: "text",
          title: "设计单位",
          hint: "请填写您的设计单位",
        },
        mold_id: {
          type: "select",
          placeholder: "请选择分类",
          title: "需求分类",
          hint: "请选择您对该需求的分类",
          options: [],
          onChange: this.moldOnChange
        },
        mold_ids: {
          type: "checkbox",
          title: "需求子分类",
          hint: "请选择您对该需求的子分类",
          options: [],
          loading: false
        },
        prov_id: {
          type: "select",
          placeholder: "请选择所在城市",
          title: "需求城市",
          hint: "请选择您的需求所在城市",
          options: [],
          onChange: false
        },
        address: {
          type: "text",
          title: "设计所在地",
          hint: "请填写您的设计所在地"
        },
        function: {
          type: "text",
          title: "项目功能",
          hint: "请填写该项目的功能",
          length: "long"
        },
        scale: {
          type: "text",
          title: "项目规模",
          hint: "请填写该项目的规模",
          length: "long"
        },
        phone: {
          type: "text",
          title: "联系电话",
          hint: "请填写您的联系电话"
        },
        content: {
          type: "textarea",
          maxlength: 200,
          title: "需求描述",
          hint: "填写描述，有利于更好的了解您的需求，限200字以内"
        }
      },
      renderBts: [
        {
          label: "发布需求",
          type: "submit",
          onClick: this.onValidate,
          classes: "fix-width",
          extendParams: {
            is_hide: 0
          }
        },
        {
          label: "支付0.9元隐藏手机发布",
          type: "submit",
          onClick: this.onValidate,
          classes: "bg-blue fix-width",
          extendParams: {
            is_hide: 1
          }
        },
        {
          label: "取消",
          type: "cancel",
          onClick: this.onCancel
        }
      ],
      dividerConfig: [
        {
          text: "需求信息",
          relatedItem: "name"
        }
      ],
      pay: {
        visible: false,
        desc: "",
        price: 0
      }
    };
  },
  watch: {
    molds(val) {
      this.renderItems.mold_id.options = val;
    },
    cities(val) {
      this.renderItems.prov_id.options = val;
    }
  },
  created() {
    this.renderItems.mold_id.options = this.molds || [];
    this.renderItems.prov_id.options = this.cities || [];
  },
  methods: {
    init() {
      this.dialogVisible = true
    },
    moldOnChange(id) {
      this.getChildMolds(id);
    },
    async getChildMolds(id) {
      this.renderItems.mold_ids.loading = true;
      const res = await molds(id);
      const { list } = res.data;
      this.renderItems.mold_ids.options = list;
      this.renderItems.mold_ids.loading = false;
    },
    onValidate(extendParams, e) {
      const target = e.currentTarget;
      const { index } = target.dataset;
      this.btCurrentIndex = index;
      if (extendParams.is_hide === 1) {
        this.onPay({
          body: "支付0.9元隐藏手机号发布需求",
          price: 0.9
        });
      } else {
        this.$refs.postForm.onFormValidate(extendParams);
        this.loading = true;
      }
    },
    onHidePhone() {},
    async onSubmit(val) {
      const formData = val;
      const that = this;
      try {
        await create(formData);
        that.$message({
          type: "success",
          message: "发布成功",
          duration: 1000,
          onClose() {
            that.$router.push({
              path: "/search/requirement"
            });
            // that.onCancel();
          }
        });
      } catch (err) {
        console.log(err);
      }
      that.loading = false;
    },
    onCancel() {
      console.log("cancel");
      this.dialogVisible = false
    },
    onPay(data) {
      this.pay = {
        visible: true,
        desc: data.body,
        price: data.price
      };
    },
    afterPay(ordernum) {
      this.payCallback(ordernum);
      // 继续发布
      this.$refs.postForm.onFormValidate({
        is_hide: 1
      });
      this.loading = true;
    },
    payCallback(ordernum) {
      this.$http.post("html/Wxpay/releaseNotify", {
        pay_money: 0.9,
        pay_type: 3,
        order_num: ordernum,
        demand_id: ""
      });
    },
    onFormError(err) {
      console.log(err);
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
 .add-requirement-dialog {
   min-width: 888px !important;
   margin-top: 5vh !important;
   .el-dialog__body {
     padding-top: 0 !important;
   }
 }
</style>
